import { render, staticRenderFns } from "./OrderBySelector.vue?vue&type=template&id=b6c84c54&scoped=true"
import script from "./OrderBySelector.vue?vue&type=script&lang=js"
export * from "./OrderBySelector.vue?vue&type=script&lang=js"
import style0 from "./OrderBySelector.vue?vue&type=style&index=0&id=b6c84c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c84c54",
  null
  
)

export default component.exports